const TABLE = (() => {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    t[n] = c >>> 0;
  }
  return t;
})();
const crc32 = (bytes) => {
  let c = 0xffffffff;
  for (let i = 0; i < bytes.length; i++) c = TABLE[(c ^ bytes[i]) & 0xff] ^ (c >>> 8);
  return (c ^ 0xffffffff) >>> 0;
};

function chunk(type, text) {
  const enc = new TextEncoder();
  const body = enc.encode(type + text);
  const out = new Uint8Array(12 + body.length - 4);
  const view = new DataView(out.buffer);
  view.setUint32(0, body.length - 4);
  out.set(body, 4);
  view.setUint32(8 + body.length - 4, crc32(body));
  return out;
}

// Adds Author/Copyright/Title iTXt chunks after IHDR; pixel data is untouched.
export async function withRights(blob, title) {
  const buf = new Uint8Array(await blob.arrayBuffer());
  const end = 8 + 8 + new DataView(buf.buffer).getUint32(8) + 4;
  const entries = [["Author", "Priyanka Jha"], ["Artist", "Priyanka Jha"], ["Copyright", "© 2026 Priyanka Jha. All rights reserved."], ["Title", title]];
  const parts = entries.map(([k, v]) => chunk("iTXt", `${k}\0\0\0\0\0${v}`));
  return new Blob([buf.slice(0, end), ...parts, buf.slice(end)], { type: "image/png" });
}

export function drawSignature(ctx, x, y, size, align = "right") {
  ctx.save();
  ctx.font = `${Math.round(size)}px "Parisienne"`;
  ctx.textAlign = align;
  ctx.textBaseline = "alphabetic";
  ctx.fillStyle = "rgba(255,255,255,0.5)";
  ctx.shadowColor = "rgba(40,20,50,0.35)";
  ctx.shadowBlur = size * 0.2;
  ctx.fillText("Priyanka Jha", x, y);
  ctx.restore();
}
